import React from 'react';
import { useNavigate } from 'react-router-dom';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  change?: string;
  color?: string;
  to?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon, change, color = 'brand', to }) => {
  const navigate = useNavigate();
  const clickable = !!to;

  return (
    <div
      className={`intrlock-stat-card bg-white rounded-xl border border-gray-200 shadow-sm p-6 ${clickable ? 'cursor-pointer hover:border-emerald-300 hover:shadow-md transition-all' : ''}`}
      onClick={clickable ? () => navigate(to!) : undefined}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {change && <p className="text-xs text-green-600 mt-1">{change}</p>}
        </div>
        <div className={`w-12 h-12 rounded-xl bg-brand-50 flex items-center justify-center text-brand-600`}>
          {icon}
        </div>
      </div>
    </div>
  );
};
